module.exports = "<Label class=\"form-control-label\" >{{label}}</Label>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/label/label.component.html
// module id = 1206
// module chunks = 322